export const NAME_REDUCER = 'giftCard';

export const PREFIX_ACTIONS = 'giftCard_feature_';

export const PATH_LOADING = {
  getGiftCardToBuy: `loading.${NAME_REDUCER}.getGiftCardToBuy`,
  getGiftCardDetail: `loading.${NAME_REDUCER}.getGiftCardDetail`,
  getListCategoryGiftCard: `loading.${NAME_REDUCER}.getListCategoryGiftCard`,
  getListGiftCardByCategory: `loading.${NAME_REDUCER}.getListGiftCardByCategory`,
};


export enum EGiftCardOnlineSendType {
  SENT_TO_ME = 'SENT_TO_ME',
  SEND_AS_GIFT = 'SEND_AS_GIFT',
}